class DescriptionToggle extends HTMLElement {
  constructor() {
    super();
    this.controller = new AbortController();
  }

  connectedCallback() {
    this.text = this.querySelector('[data-description-text]');
    this.toggle = this.querySelector('[data-description-toggle]');
    this.showMore = this.getAttribute('data-show-more');
    this.showLess = this.getAttribute('data-show-less');

    if (!this.text || !this.toggle) return;

    this.updateToggleVisibility();

    let resizeTimeout;
    window.addEventListener(
      'resize',
      () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => this.updateToggleVisibility(), 150);
      },
      { signal: this.controller.signal }
    );

    this.toggle.addEventListener(
      'click',
      () => {
        const isExpanded = this.text.classList.toggle('expanded');
        this.toggle.textContent = isExpanded ? this.showLess : this.showMore;
      },
      { signal: this.controller.signal }
    );
  }

  disconnectedCallback() {
    this.controller.abort();
  }

  updateToggleVisibility() {
    const text = this.text;
    const isExpanded = text.classList.contains('expanded');

    if (isExpanded) {
      this.toggle.style.display = '';
      return;
    }

    const isTruncated = text.scrollHeight > text.clientHeight;
    this.toggle.style.display = isTruncated ? '' : 'none';
  }
}

if (!customElements.get('description-toggle')) {
  customElements.define('description-toggle', DescriptionToggle);
}
